import React  from 'react'
import { GetExternalChannelsList } from '../../../api/services/pms';
import DropDown from '../dropdown';

const ExternalChannelDropDown = ({...props}) => {
    return <DropDown api={GetExternalChannelsList} textField="Name" valueField="Id"  {...props}/>
}

export default ExternalChannelDropDown